/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
	// Add custom code below this line

	/**
	 * 
	 * GLOBAL
	 */
	// let productJSON = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
	// console.log('productJSON', productJSON);
	// let variantsCombinationsJSON = JSON.parse(document.querySelector('[data-variants-combination]').innerHTML);
	// console.log('variantsCombinationsJSON', variantsCombinationsJSON);
	/* SendinBlue Form */
	const targetNodeLang = document.querySelector('html');
	let my_sib_forms = document.querySelectorAll('.sib-form');

	function switchFromParams() {
		// console.log('OK!');
		// console.log('exists?', document.querySelectorAll('.sib-form').length > 0 ? true : false);
		let my_lang = targetNodeLang.getAttribute('lang');
		const it_action = 'https://aa285c62.sibforms.com/serve/MUIEANQtSPWj-qwGehVhDtLmgi6bA3z_KJFU5BYUwuAZ3ZBnXn14BPRdpoQ49Ss2Tu_Lq0ReOwP90QMYzOY4-mnhO89Xy9kO-_qWtQXaDVCrHyzGoF9Wt1gOzGrscEJpBMhoaOhw7C3gGEWWAJVJ6kxFZKSN1gyK41v5v5va_BnTq1FlAqIelZtp0qFZcslE2ipcuHcAwdjEm-2g';
		const en_action = 'https://aa285c62.sibforms.com/serve/MUIEAEVgvOLyjT1oefdBHpys7CnP8tGESifMlKYxfjGJAvZ6nEWPK6D_kxbWnCZu_f5avfjtPCbUcJoBhwVxEzqV700Cv7IYoZMASTdXViyJDXRgs5m13Pq7Eyc4ipRoRa9D2tn2DMDpm0qsQDQojZ1_PKNKUO3zU-jFFrouwgMF-3FBu1VcCreQ8UoQyIeYXWv_nW46IIOjPSS6';
		const de_action = 'https://aa285c62.sibforms.com/serve/MUIEAFWu3VP2h2xgdKRtUb6LTJvmlnn5N5ioWfPe4cGE8uhI0sfUqe-_9gWkA3H_8mHGmbmnFh1kq7rnnPZnQq6c1WNSMpaLGX7WRUSCpYdhyocNuWj8aOnKbkSeNoasbSFnxOZd8YtnKBr1gmdfJbkSp3EhaAiQ5LUFrvLEowKC-scfdRMk8MDzjjtThnK4HmxXrkaJvuYg6I0H';
		let my_action = eval(my_lang + '_action');
		let my_form = document.getElementById('sib-form');
		let is_milano = document.getElementById('iscrizione-store-milano');
		let is_inl = document.getElementById('iscrizione-nl');
		// console.log('is_milano', is_milano);
		if (!is_milano && !is_inl) {
			// console.log('my_sib_forms', my_sib_forms);

			my_sib_forms.forEach((form_item) => {
				// console.log('form_item', form_item);
				let my_single_sib_form = form_item.querySelector('#sib-form');
				// console.log('my_single_sib_form', my_single_sib_form);
				let sib_form_hidden = my_single_sib_form.querySelector('input[name="locale"]');
				my_single_sib_form.action = my_action;
				sib_form_hidden.value = my_lang;
			});

			// my_form.action = my_action;
			// sib_form_hidden.value = my_lang;
		}
		// my_form.action = my_action;
		// sib_form_hidden.value = my_lang;
		window.LOCALE = my_lang;
	}

	/*
	my_sib_forms.forEach((form_item) => {
		let sib_button = form_item.querySelector('.sib-form-block__button');
		sib_button.addEventListener("click", clickHandler);
	});
	function clickHandler(clickEvent) {
		clickEvent.preventDefault();
		console.log('currentTarget', clickEvent.currentTarget);

		console.log('EMAIL:', clickEvent.currentTarget.closest('#sib-form').querySelector('#EMAIL').value);
		my_sib_forms.forEach((form_item) => {
			form_item.querySelector('#EMAIL').value = clickEvent.currentTarget.closest('#sib-form').querySelector('#EMAIL').value;
			if (form_item.querySelector('#EMAIL').value !== '') clickEvent.currentTarget.closest('#sib-form').submit();
		});
	}
	*/

	/* Add to cart */
	function switchAddCart() {
		let my_lang = targetNodeLang.getAttribute('lang');
		let add_to_cart = document.querySelector('[data-add-to-cart-text]');
		let tttt = document.querySelector('[data-culture]');
		tttt.setAttribute('data-culture', my_lang);
		if (add_to_cart) {
			switch (my_lang) {
				case 'it':
					add_to_cart.innerHTML = 'Aggiungi al carrello';
					break;
				case 'de':
					add_to_cart.innerHTML = 'in den Warenkorb';
					break;
				case 'en':
					add_to_cart.innerHTML = 'Add to cart';
					break;
			
				default:
					add_to_cart.innerHTML = 'Add to cart';
					break;
			}
		}
	}

	switchFromParams();
	switchAddCart();
	if (targetNodeLang) {
		const configLang = { attributes: true, childList: false, subtree: false };

		const callback = function(mutationsList, observerLang) {
			// console.log('test', mutationsList, observerLang);
			switchFromParams();
			switchAddCart();
		};

		const observerLang = new MutationObserver(callback);
		observerLang.observe(targetNodeLang, configLang);
	}

	/* Cart */
	let checker = document.getElementById('cart-tec');
	let checker2 = document.getElementById('cart-tec-2');
	if (checker && checker2) {
		checker.value = false;
		checker2.value = false;
		let sendbtn = document.getElementById('cart-tec-checkout');
		let must_accept = document.querySelector('.must-accept');
		// console.log('checker', checker);
		// console.log('sendbtn', sendbtn);
		checker.onchange = function() {
			// console.log('test', !this.checked);
			this.value = this.checked;
			if (this.checked && checker2.checked) {
				must_accept.classList.add('must-accept-hidden');
			}
			// sendbtn.disabled = !this.checked;
		};
		checker2.onchange = function() {
			// console.log('test', !this.checked);
			this.value = this.checked;
			if (this.checked && checker.checked) {
				must_accept.classList.add('must-accept-hidden');
			}
			// sendbtn.disabled = !this.checked;
		};

		if (sendbtn) {
			sendbtn.addEventListener("click", (event) => {
				// alert('checkbox');
				// console.log('checker.checked', checker.checked);
				if (!checker.checked || !checker2.checked) {
					// alert('checkbox');
					must_accept.classList.remove('must-accept-hidden');
					event.preventDefault();
					event.stopPropagation();
					return false;
				} else {
					console.log('GO TO CHECKOUT');
				}
			});
		}
	}


	/**
	 * 
	 * PDP
	 */
	
	/* COLOR SWATCHES BY SELECTED VARIANT */
	function excludeUnavailableColorSwatches(my_selected_option1) {
		const productJSON = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
		const variantsCombinationsJSON = JSON.parse(document.querySelector('[data-variants-combination]').innerHTML);
		const currentVariantID = document.querySelector('.product-form input[name="id"]').value;
		// console.log('my_selected_option1', my_selected_option1);
		// console.log('currentVariantID', currentVariantID);

		const everySwatches = document.querySelectorAll('.swatch__button');
		everySwatches.forEach((item) => {
			item.classList.remove('color-swatch-disabled');
		});

		let result = productJSON.variants.filter(function (variant) {
			// console.log('variant', variant);
			return variant.id === Number(currentVariantID);
		});
		let my_variant = result[0];

		if (my_selected_option1) {
			my_variant = true;
		}

		if (!my_variant) {
			console.log('NOT MY VARIANT');
			everySwatches.forEach((item) => {
				item.classList.add('color-swatch-disabled');
			});
			// return;
		} else {
			// console.log('option1', my_variant.option1);
			let my_variant_option1 = my_variant.option1;
			if (my_selected_option1) {
				my_variant_option1 = my_selected_option1;
			}
			let selected_size_colors = variantsCombinationsJSON[my_variant_option1].toLowerCase();
			// console.log('selected_size_colors', selected_size_colors);
			let selected_size_colors_split = selected_size_colors.split(',');
			// console.log('first_available_color', selected_size_colors_split[0]);
			let previous_checked_color = document.querySelector('[color-data-single-option-selector]:checked').value.toLowerCase();
			// console.log('previous_checked_color', previous_checked_color);
			everySwatches.forEach((item) => {
				// item.classList.remove('color-swatch-disabled');
				// console.log('item', item);
				let dataTooltip = item.getAttribute('data-tooltip-custom').toLowerCase();
				// console.log('dataTooltip', dataTooltip);
				// let is_matching = selected_size_colors.indexOf(dataTooltip) > -1;
				let is_matching =  new RegExp(`^${selected_size_colors}$`.split(",").join("$|^")).test(dataTooltip);
				// console.log('is_matching', is_matching);
				if (!is_matching) {
					item.classList.add('color-swatch-disabled');
				}

				let my_inputs = document.querySelectorAll('[color-data-single-option-selector]');
				const location = window.location.href;
				if (location.includes('/product')) {
					const url = new window.URL(location);
					const params = url.searchParams;
					if (my_inputs) {
						my_inputs.forEach((input) => {
							input.checked = false;
							let is_matching_previous =  new RegExp(`^${selected_size_colors}$`.split(",").join("$|^")).test(previous_checked_color);
							// console.log('is_matching_previous', is_matching_previous);
							if (
								// selected_size_colors.indexOf(previous_checked_color) > -1
								is_matching_previous
								&& input.value.toLowerCase() == previous_checked_color
							) {
								input.checked = true;
							} else if (input.value.toLowerCase() == selected_size_colors_split[0]) {
								input.checked = true;
							}
						});
					}
					// document.getElementById('7323248132249-Color-Beige Medio Cammello').checked = true;
					// params.set('variant', 41972871168153);
					// document.querySelector('.product-form input[name="id"]').value = 41972871168153;
					url.search = params.toString();
					const urlString = url.toString();
					window.history.replaceState({path: urlString}, '', urlString);
				}
			});
		}
	}

	let p_template = document.querySelector('.template-product');
	if (p_template) {
		const size_checked = document.querySelector('.radio__fieldset .radio__button input:checked').value;
		excludeUnavailableColorSwatches(size_checked);
		const everySizes = document.querySelectorAll('.size-data-single-option-selector');
		everySizes.forEach((item) => {
			item.addEventListener("click", (event) => {
				// console.log('event', event.currentTarget);
				excludeUnavailableColorSwatches(event.currentTarget.value);
			});
		});
	}

	/* Carousel */
	function changeMediaBySelectedVariant() {
		const productJSON = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
		// product-form
		const currentVariantID = document.querySelector('.product-form input[name="id"]').value;
		// console.log('currentVariantID', currentVariantID);

		let result = productJSON.variants.filter(function (variant) {
			// console.log('variant', variant);
			return variant.id === Number(currentVariantID);
		});
		const my_variant = result[0];
		if (!my_variant) return;
		// console.log('my_variant', my_variant);
		const my_barcode = my_variant.barcode;
		const my_sku = my_variant.sku;
		// console.log('my_barcode', my_barcode);
		// console.log('my_sku', my_sku);

		// product__slide
		const everySlides = document.querySelectorAll('.product__slide');
		window.scrollTo(
			{
				top: 0,
				left: 0,
				behavior: 'smooth'
			}
		);
		everySlides.forEach((item) => {
			item.classList.add('custom--product__slide');
			// console.log('item', item);

			let dataThumb = item.getAttribute('data-thumb');
			let dataVideoAlt = item.getAttribute('data-video-alt');
			// console.log('dataThumb', dataThumb);
			/*let is_matching = dataThumb.indexOf(my_barcode) > -1 || dataThumb.indexOf(my_sku) > -1;*/
			let is_matching = (dataThumb.indexOf(my_barcode) > -1 && my_barcode != '') || dataThumb.indexOf(my_sku) > -1 || (dataVideoAlt && dataVideoAlt.indexOf(my_sku) > -1);
			// console.log('is_matching', is_matching);
			if (is_matching) {
				item.classList.remove('custom--product__slide');
			}
		});
	};

	let variantIdInput = document.querySelector('.product-form input[name="id"]');
	
	if (p_template) {
		changeMediaBySelectedVariant();
		if (variantIdInput) {
			const configVariantIdInput = { attributes: true, childList: false, subtree: false };

			const callback = function(mutationsList, observerVariantIdInput) {
				// console.log('test', mutationsList, observerVariantIdInput);
				changeMediaBySelectedVariant();
			};

			const observerVariantIdInput = new MutationObserver(callback);
			observerVariantIdInput.observe(variantIdInput, configVariantIdInput);
		}
	}

	/* Sticky Form */
	function changeStickyTop() {
		// console.log('changeStickyTop----');
		let $sticky = document.querySelector(".form__wrapper.with-sticky-header");
		if (!$sticky) return;
		// console.log('sticky', $sticky);
		if (window.innerWidth <= 750) {
			$sticky.style.top = "";
			return;
		}
		$sticky.style.top = `${window.innerHeight - $sticky.clientHeight}px`;
	}

	window.addEventListener('resize', () =>  {
		changeStickyTop();
	});
	
	const targetNode = document.querySelector('.tabs-wrapper');

	if (targetNode) {
		const config = { attributes: true, childList: true, subtree: true };

		const callback = function(mutationsList, observer) {
			// console.log('test', mutationsList, observer);
			changeStickyTop();
		};

		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);
	}



	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="language_code"], input[name="country_code"]')
			};
			this.querySelectorAll('select').forEach(item => {
				//console.log('element', item);
				item.addEventListener('change', this.onItemClick.bind(this));
			});
		}
		
		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			this.elements.input.value = event.target.value;
			if (form) form.submit();
		}
	}

	if (document.querySelector('localization-form')) customElements.define('localization-form', LocalizationForm);
	// ^^ Keep your scripts inside this IIFE function call to 
	// avoid leaking your variables into the global scope.
})();
